export function getItemCosts(job, dateRange, jobAliases) {
    let { getItemCostsRequest, getItemCostsError, getItemCostsResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'get_item_costs',
        this.createBundle('get_item_costs', { job, dateRange, jobAliases }, this.POST, getItemCostsRequest, getItemCostsResult, getItemCostsError)
    )
}
